import session from './session'
import format from 'string-format'

export default {

	/**
	 * Функция ищет любую библиотеку по названию (name).
	 * Для алгоритмов.
	 * @param name
	 * @returns {*}
	 */
	get_lib_by_name: function (name) {
		return session.get(format('/ngs_lib/?name={0}', name))
	},

	/**
	 * Функция ищет любую библиотеку с заданым названием.
	 * Использовать только из интерфейса поиска по вводу пользователя.
	 * НЕ использовать из алгоритмов.
	 * @param name
	 * @returns {*}
	 */
	search_lib_by_name: function (name) {
		return session.get(format('/ngs_lib/?search={0}', name))
	},
}